export default __webpack_public_path__ + "static/gitdone-26cf058f5ee595e0787ca9d0a9905d81.svg";